export const AUTO_REPLIES_COPY = {
    formTitle: 'Автоответы',
    defaultScenarioName: 'Новый сценарий',
    enableScenario: 'Включить',
    disableScenario: 'Отключить',
    scenarioEnabled: 'Включен',
    scenarioDisabled: 'Выключен',
    dragScenario: (position: number): string => `Перетащить сценарий ${position}`,
    expandScenario: (name: string): string => `Развернуть сценарий ${name}`,
    collapseScenario: (name: string): string => `Свернуть сценарий ${name}`,
} as const;

export const AUTO_REPLIES_FORM_TITLE = AUTO_REPLIES_COPY.formTitle;
export const AUTO_REPLY_DEFAULT_SCENARIO_NAME = AUTO_REPLIES_COPY.defaultScenarioName;
